/**
 * Detect whether the current host is a custom checkout domain (not the platform
 * host). When `true`, the app should only serve customer-facing checkout pages
 * (/checkout/*) and the admin dashboard (/admin/*). All other routes — public
 * storefronts, the landing page, campaign URLs — should be blocked so the
 * domain doesn't leak the main app's branding/discoverability.
 *
 * IMPORTANT: this purposely does NOT compare against REACT_APP_BACKEND_URL.
 * If the user configures REACT_APP_BACKEND_URL to point at their custom domain
 * (legitimate, for traffic isolation), the equality check would mis-classify
 * the page as "platform" and unlock the landing. The only reliable signal is
 * whether the current host ends in an Emergent infra suffix.
 */
const EMERGENT_HOST_REGEX = /\.emergentagent\.com$|\.emergent\.host$|\.deploy\.emergentagent\.com$/;

export function isCustomDomain() {
  if (typeof window === 'undefined') return false;
  try {
    const currentHost = window.location.host;
    // Strip port if any (defensive against http://localhost:3000 in dev).
    const hostNoPort = currentHost.split(':')[0];
    // Local dev / staging exception: localhost & private IPs are NEVER custom.
    if (hostNoPort === 'localhost' || hostNoPort === '127.0.0.1' || hostNoPort.endsWith('.localhost')) {
      return false;
    }
    if (EMERGENT_HOST_REGEX.test(hostNoPort)) return false;
    return true;
  } catch {
    return false;
  }
}
